<template>
  <div class="table-responsive">
    <div class="d-flex flex-md-row flex-column justify-content-md-between align-items-center">
      <filter-bar @filter="onFilterSet"></filter-bar>
      <span v-if="ucitavanjeSvih" class="sve-uputnice-btn">
        <span class="fa fa-spinner fa-spin"></span>
        Preuzimanje uputnica...
      </span>
      <!-- Samo ako automatsko preuzimanje pri otvaranju nije uspjelo -->
      <button
        v-else-if="uvozNeuspio"
        class="btn btn-sm btn-primary sve-uputnice-btn"
        @click="sveUputnice"
      >
        Sve uputnice
      </button>
      <div class="per-page">
        <label for="uputnice-per-page">{{ 'Prikaži' }}</label>
        <select id="uputnice-per-page" class="form-control" v-model.number="brStr" @change="onPerPageChange">
          <option v-for="n in perPageOptions" :key="n" :value="n">{{ n }}</option>
        </select>
      </div>
    </div>
    <vuetable
      ref="vuetable"
      :apiUrl="apiUrl"
      :apiMode="apiMode"
      :fields="tableFields"
      :data="tableData"
      :dataTotal="dataCount"
      :dataManager="dataManager"
      :css="css.table"
      data-path="data"
      v-bind:paginationPath="paginationPath"
      :appendParams="moreParams"
      :perPage="brStr"
      :datum="perPage"
      :token="token"
      :site="site"
      v-on:vuetable:cell-clicked="(...args)=>this.prikaziDetalje([args])"
      @vuetable:pagination-data="onPaginationData"
    >
      <template slot="status" slot-scope="props">
        <button
          class="btn btn-sm"
          :class="props.rowData.status === 'aktiviran' ? 'btn-success disabled' : 'btn-primary'"
          :disabled="props.rowData.status === 'aktiviran' || aktiviranjeUToku === props.rowData._id"
          @click.stop="aktiviraj(props.rowData)"
        >
          <span v-if="aktiviranjeUToku === props.rowData._id" class="fa fa-spinner fa-spin"></span>
          {{ props.rowData.status === 'aktiviran' ? 'Aktiviran' : 'Aktiviraj' }}
        </button>
      </template>
    </vuetable>

    <div class="d-flex flex-md-row flex-column justify-content-md-between align-items-center mb-4">
      <vuetable-pagination-info
        ref="paginationInfo"
        :infoTemplate="'Prikazano {from} - {to} od {total} uputnica'"
        :noDataTemplate="'Nema uputnica'"
      ></vuetable-pagination-info>
      <vuetable-pagination
        ref="pagination"
        :css="css.pagination"
        :onEachSide="onEachSide"
        @vuetable-pagination:change-page="onChangePage"
      ></vuetable-pagination>
    </div>

  </div>
</template>

<script>
import Vue from "vue";
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo";
import LocalData from "./data/local-data";
import DataTableStyles from "./data/data-table-styles";
import FilterBar from "./datatable-components/FilterBar.vue";
import router from "../../router";
import { http } from "../../../config/config.js";
import { bus } from "../../main.js";

const originalData = LocalData.data;

export default {
  name: "uputnice-table",

  components: {
    FilterBar,
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo
  },
  props: {
    site: {
      type: String
    },
    token: {
      type: String
    },
    sekcija: {
      type: String
    },
    apiUrl: {
      type: String
    },
    tableFields: {
      type: Array,
      required: true
    },
    onEachSide: {
      type: Number,
      default() {
        return 2;
      }
    },
    apiMode: {
      type: Boolean,
      default() {
        return true;
      }
    },
    data: {
      type: Array
    },
    sortFunctions: {
      type: Object
    },
    paginationPath: {
      type: String,
      default() {
        return "";
      }
    }
  },
  data() {
    return {
      tableData: LocalData,
      perPage: "",
      brStr: 10,
      perPageOptions: [10, 20, 50, 100],
      colorClasses: {},
      moreParams: {},
      dataCount: 0,
      css: DataTableStyles,
      pacijent: {},
      show: true,
      potvrdi: "SAČUVAJ",
      odustani: "ZATVORI",
      patient_data: {},
      // Toasts
      toastText: "",
      toastIcon: "",
      toastPosition: "",
      toastDuration: 2500,
      isToastFullWidth: false,
      className: "",
      aktiviranjeUToku: null,
      ucitavanjeSvih: false,
      uvozNeuspio: false
    };
  },
  mounted() {
    this.onFilterSet(this.$store.state.filter);
    bus.$on("Set", data => {
      this.onFilterSet(data.ime + " " + data.prezime);
    });
    bus.$on("UputniceOsvjezi", () => {
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    });
    this.sveUputnice();
  },
  beforeDestroy() {
    bus.$off("Set");
    bus.$off("UputniceOsvjezi");
  },
  watch: {},
  methods: {
    unosPacijenta() {
      this.$refs.largeModalPatient.open();
    },
    prikaziDetalje: function(args) {

      var niz = args[0];

      if (
        args[0][2].srcElement.cellIndex === undefined &&
        !args[0][2].srcElement.classList.contains("disabled")
      ) {
        if (niz[1].name === "detalji") {
          this.pacijent = niz[0].id;
          this.Patient();
        }
        if (niz[1].name === "prijem") {
          router.push("/samples/" + args[0][0].id);
        }
       if (niz[1].name === "uputnice") {
          //router.push("/samples/" + args[0][0].id);
                console.log("niz[1].name")
      console.log(args[0])
       this.Uputnica(args[0][0].id);
        }
        // if (niz[1].name === "icon") {
        //   if(this.$store.state.access.level < 1){
        //     router.push("/evaluation/" + args[0][0].id);
        //   }           
        // }
      }
    },
    Patient() {
      http
        .get(
          "pacijenti/detalji/" +
            this.pacijent +
            "?token=" +
            this.$store.state.token +
            "&site=" +
            this.$store.state.site,
          {}
        )
        .then(res => {

          if (res.data.pacijent.jmbg != undefined) {
            this.patient_data = res.data.pacijent;
            this.$refs.modalPatientEdit.open();
          }
        });
    },
        Uputnica(id) {
      // Samo brojevi -> pretraga po ID uputnice (RID), inače po imenu i prezimenu (NAME)
      const vrijednost = String(id).trim();
      const poImenu = !/^\d+$/.test(vrijednost);
      http
        .get("api/uputnica", {
          params: {
            identificatorValue: vrijednost,
            identificatorType: poImenu ? "NAME" : "RID",
            token: this.$store.state.token,
            site: this.$store.state.site
          }
        })
        .then(res => {
          if (res.data.success && res.data.data && res.data.data.results && res.data.data.results.length) {
            if (!poImenu) {
              bus.$emit("GHealthUputnicaShow", res.data.data.results[0]);
              return;
            }
            // Svaka narudžba svakog pronađenog pacijenta je zasebna uputnica za odabir
            const uputnice = [];
            res.data.data.results.forEach(result => {
              (result.orders || []).forEach(order => {
                uputnice.push({ patient: result.patient, orders: [order] });
              });
            });
            if (uputnice.length === 1) {
              bus.$emit("GHealthUputnicaShow", uputnice[0]);
            } else if (uputnice.length > 1) {
              bus.$emit("GHealthUputniceIzbor", uputnice);
            } else {
              this.showToast("Pacijent nema aktivnih uputnica.", {
                icon: "fa-warning",
                position: "top-right",
                duration: this.toastDuration,
                className: "vuestic-toast-warning"
              });
            }
          } else {
            this.showToast(res.data.message || "Uputnica nije pronađena.", {
              icon: "fa-warning",
              position: "top-right",
              duration: this.toastDuration,
              className: "vuestic-toast-warning"
            });
          }
        })
        .catch(() => {
          this.showToast("Greška pri pretraživanju uputnica.", {
            icon: "fa-remove",
            position: "top-right",
            duration: this.toastDuration,
            className: "vuestic-toast-danger"
          });
        });
    },
    // Sve aktivne G-Health uputnice laboratorije (šalje se samo laboratoryCode, server ga
    // određuje prema site-u) se automatski snimaju u LIS i prikazuju u tabeli za aktiviranje.
    // Već snimljene uputnice server preskače. Pokreće se pri otvaranju, a dugmetom
    // "Sve uputnice" ponovo samo ako preuzimanje nije uspjelo.
    sveUputnice() {
      this.ucitavanjeSvih = true;
      this.uvozNeuspio = false;
      http
        .get("api/uputnica", {
          params: {
            token: this.$store.state.token,
            site: this.$store.state.site
          }
        })
        .then(res => {
          if (!res.data.success) {
            throw new Error(res.data.message || "Greška pri preuzimanju uputnica.");
          }
          // Svaka narudžba svakog pacijenta je zasebna uputnica
          const uputnice = [];
          ((res.data.data && res.data.data.results) || []).forEach(result => {
            (result.orders || []).forEach(order => {
              uputnice.push({ patient: result.patient, orders: [order] });
            });
          });
          // Jedna po jedna, da server pouzdano preskoči već snimljene
          let greske = 0;
          return uputnice
            .reduce(
              (prethodna, uputnica) =>
                prethodna.then(() =>
                  this.snimiUputnicu(uputnica).catch(e => {
                    greske++;
                    console.log("G-Health uputnica " + uputnica.orders[0].id + " nije snimljena:", e.message);
                  })
                ),
              Promise.resolve()
            )
            .then(() => {
              if (greske) {
                this.showToast("Nije snimljeno uputnica: " + greske + " od " + uputnice.length + ".", {
                  icon: "fa-warning",
                  position: "top-right",
                  duration: this.toastDuration,
                  className: "vuestic-toast-warning"
                });
              }
            });
        })
        .then(() => {
          this.ucitavanjeSvih = false;
          Vue.nextTick(() => this.$refs.vuetable.refresh());
        })
        .catch(e => {
          this.ucitavanjeSvih = false;
          this.uvozNeuspio = true;
          this.showToast((e && e.message) || "Greška pri preuzimanju uputnica.", {
            icon: "fa-remove",
            position: "top-right",
            duration: this.toastDuration,
            className: "vuestic-toast-danger"
          });
        });
    },
    // Snima samo uputnicu u LIS (bez pacijenta i uzoraka - kreiraju se pri aktiviranju)
    snimiUputnicu(uputnica) {
      return http
        .post("api/uputnica/save", {
          token: this.$store.state.token,
          site: this.$store.state.site,
          result: uputnica
        })
        .then(res => {
          if (!res.data.success) throw new Error(res.data.message || "Greška pri snimanju");
        });
    },
    onFilterSet(filterText, event) {

      this.filterString = ""

      this.filterString = filterText
      
      if(event != undefined && filterText.trim() != ''){

        

         if (filterText.length === 14 && filterText.charAt(0) === "0") {
          
          filterText = filterText.replace(/^0/, "");
            console.log("Lična karta ili vozačka dozvola")
          } 

        

        if(!isNaN(filterText) && filterText.length == 13){
          if (this.apiMode) {
            this.moreParams = {
              filter: filterText
            };
          } else {
            const txt = new RegExp(filterText, "i");
            this.tableData.data = originalData.filter(function(item) {
              return item.name.search(txt) >= 0 || item.email.search(txt) >= 0;
            });
          }
          
          Vue.nextTick(() => this.$refs.vuetable.refresh());
          
        }else

        if(event.keyCode == 13){

          if (this.apiMode) {
            this.moreParams = {
              filter: filterText
            };
          } else {
            const txt = new RegExp(filterText, "i");
            this.tableData.data = originalData.filter(function(item) {
              return item.name.search(txt) >= 0 || item.email.search(txt) >= 0;
            });
          }
          
          Vue.nextTick(() => this.$refs.vuetable.refresh());
           this.Uputnica(filterText)
        }else{
          // console.warn('Waiting for Enter...')
        }

      }else{

        if (this.apiMode) {
          this.moreParams = {
            filter: filterText
          };
        } else {
          const txt = new RegExp(filterText, "i");
          this.tableData.data = originalData.filter(function(item) {
            return item.name.search(txt) >= 0 || item.email.search(txt) >= 0;
          });
        }
        Vue.nextTick(() => this.$refs.vuetable.refresh());
      }
    },
    // Aktiviranjem se u LIS-u kreiraju pacijent i uzorci uputnice (sa novim brojem protokola),
    // uputnica se aktivira na G-Health i printaju se barkodovi
    aktiviraj(row) {
      this.aktiviranjeUToku = row._id;
      const auth = { token: this.$store.state.token, site: this.$store.state.site };
      http
        .get("postavke/protokol/get", { params: auth })
        .then(res => {
          if (!res.data.success) throw new Error("Broj protokola nije dostupan.");
          const godina = JSON.stringify(new Date().getFullYear()).substring(2, 4);
          return http.post(
            "api/uputnica/activate",
            Object.assign(
              {
                protokol: row.uputnica,
                BrojProtokola: JSON.stringify(Number(res.data.Data.count) + 1) + "/" + godina
              },
              auth
            )
          );
        })
        .then(res => {
          this.aktiviranjeUToku = null;
          // Broj protokola je potrošen čim su kreirani uzorci, i kad G-Health aktivacija ne uspije
          if (res.data.uzorciKreirani) {
            http.post("postavke/protokol/set", auth);
          }
          if (res.data.success) {
            //BARCODE BARKOD - print pri aktivaciji
            (res.data.barkodovi || []).forEach((element) => {
              var datum = element.datum || "";
              var temp = datum.split("-");
              if (temp.length === 3) {
                datum =
                  temp[2].substring(0, 2) +
                  "." +
                  temp[1] +
                  "." +
                  temp[0].substring(2, 4) +
                  " " +
                  temp[2].substring(3, 8);
              }
              console.log("Uputnica aktivirana printam barkod " + element.sid);
              printEPL(
                element.patient,
                element.sid,
                element.pid,
                element.godiste,
                datum,
                element.link,
                element.code,
                this.$store.state.site,
                undefined,
                element.protokol
              );
            });
            this.showToast("Uputnica uspješno aktivirana.", {
              icon: "fa-check",
              position: "top-right",
              duration: this.toastDuration,
              className: "vuestic-toast-primary"
            });
            Vue.nextTick(() => this.$refs.vuetable.refresh());
          } else {
            this.showToast(res.data.message || "Greška pri aktiviranju uputnice.", {
              icon: "fa-remove",
              position: "top-right",
              duration: this.toastDuration,
              className: "vuestic-toast-danger"
            });
          }
        })
        .catch(e => {
          this.aktiviranjeUToku = null;
          this.showToast((e && e.message) || "Greška pri konekciji sa serverom.", {
            icon: "fa-remove",
            position: "top-right",
            duration: this.toastDuration,
            className: "vuestic-toast-danger"
          });
        });
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onPerPageChange() {
      // Nova veličina stranice - refresh() vraća na prvu stranicu
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    dataManager(sortOrder, pagination) {
      let data = this.tableData.data;
      let sortFunctions = this.sortFunctions;

      if (sortOrder.length > 0) {
        data.sort(function(item1, item2) {
          const sortField = sortOrder[0].sortField;
          let fn = sortFunctions[sortField];
          if (fn) {
            return fn(item1[sortField], item2[sortField]);
          }
        });

        if (sortOrder[0].direction === "desc") {
          data.reverse();
        }
      }

      pagination = this.$refs.vuetable.makePagination(data.length);

      return {
        pagination: pagination,
        data: data.slice(pagination.from - 1, pagination.to)
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/variables";
@import "../../sass/toasts";

@media (max-width: 1258px) {
  .pagination-link-btn:first-child,
  .pagination-link-btn:last-child {
    display: none;
  }
  .pagination-link-btn:nth-child(2) {
    border-top-left-radius: $btn-border-radius !important;
    border-bottom-left-radius: $btn-border-radius !important;
  }
  .pagination-link-btn:nth-last-child(2) {
    border-top-right-radius: $btn-border-radius !important;
    border-bottom-right-radius: $btn-border-radius !important;
  }
}

@media (max-width: 576px) {
  .hide-not-focused-btn:not(.focus) {
    display: none;
  }
}

.btn.btn-info {
  text-transform: none;
}

.sve-uputnice-btn {
  margin: 0.5rem 0;
}

.per-page {
  display: flex;
  align-items: center;

  label {
    margin: 0 0.5rem 0 0;
  }

  select {
    width: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/02_uputnice/UputniceTable.vue